export const WIDGET_ACTION = {
  createBlankProject: 'create_blank_project',
  improveContent: 'improve_content',
  openTemplateGallery: 'open_template_gallery',
  openSavedTemplates: 'open_saved_templates',
  submit: 'submit',
};

export const CLASSIFIED_TEMPLATE_BLOG = 'blog';
